export const MAP_MAIN_BUILD_CONTAINER_DIV_ID = "main-build-container";
// Do we want to display itemized site work and unit on catalog product cards?
export const MAP_MAIN_INNER_CONTAINER_DIV_ID = "main-build-container";
